"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotifyMe = void 0;
var OpenBackInStockNotificationDialog = _interopRequireWildcard(require("@ori-events/open-back-in-stock-notification-dialog"));
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const NotifyMe = ({
  code,
  disabled,
  size = 'medium',
  onNotifyMeButtonClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onClickHandler = (0, _react.useCallback)(event => {
    event.preventDefault();
    event.stopPropagation();
    if (onNotifyMeButtonClick) {
      onNotifyMeButtonClick();
    } else {
      window.dispatchEvent(new CustomEvent(OpenBackInStockNotificationDialog.Name, {
        detail: {
          code
        }
      }));
    }
  }, [code, onNotifyMeButtonClick]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NotifyMeIconButton, {
    "data-testid": `${getTestId(_constants.NOTIFY_ME)}-${code}`,
    color: "default",
    disabled: disabled,
    hoverIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.NotificationFilled, {
      "data-testid": getTestId(_constants.NOTIFICATION_FILLED),
      fontSize: "inherit"
    }),
    size: size,
    variant: "contained",
    onClick: onClickHandler,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Notification, {
      "data-testid": getTestId(_constants.NOTIFICATION),
      fontSize: "inherit"
    })
  });
};
exports.NotifyMe = NotifyMe;
//# sourceMappingURL=NotifyMe.js.map